interface iconsColor {
  color?: string;
  className?: string;
}
export const ArrowLeft: React.FC<iconsColor> = ({ color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66666 16L25.3333 16"
        stroke={color ? `${color}` : `#ffffff`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 10.6665L6.66666 15.9998L12 21.3332"
        stroke={color ? `${color}` : `#ffffff`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ArrowRight: React.FC<iconsColor> = ({ color, className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"
        fill={color ? color : `#777B7D`}
      />
    </svg>
  );
};

export const SearchIcon: React.FC<iconsColor> = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 15L19 19"
        stroke={color ? color : `#777B7D`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="11"
        cy="11"
        r="5.25"
        stroke={color ? color : `#777B7D`}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const CartIcon: React.FC<iconsColor> = ({ color }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_32_550)">
        <path
          d="M0.748974 0C0.336154 0 0 0.344262 0 0.76704C0 1.18982 0.336154 1.53408 0.748974 1.53408H3.63872L6.2159 13.994C6.31615 14.4651 6.61692 14.8516 7.00026 14.8516H19.5028C19.8979 14.8516 20.2636 14.4892 20.2636 14.0846C20.2636 13.6799 19.8979 13.3115 19.5028 13.3175H7.61359L7.29513 11.7834H20.5113C20.8474 11.7834 21.1659 11.5177 21.2367 11.1855L22.9882 3.50302C23.0885 3.05608 22.7051 2.56687 22.2628 2.56687H5.39026L4.98333 0.616048C4.91256 0.265746 4.5941 0 4.25205 0H0.748974ZM5.70282 4.09491H21.3074L19.9097 10.2433H6.97667L5.70282 4.09491ZM9.75436 15.8783C8.38026 15.8783 7.25385 17.0319 7.25385 18.4392C7.25385 19.8464 8.38026 21 9.75436 21C11.1285 21 12.2549 19.8464 12.2549 18.4392C12.2549 17.0319 11.1285 15.8783 9.75436 15.8783ZM16.7546 15.8783C15.3805 15.8783 14.2541 17.0319 14.2541 18.4392C14.2541 19.8464 15.3805 21 16.7546 21C18.1287 21 19.2551 19.8464 19.2551 18.4392C19.2551 17.0319 18.1287 15.8783 16.7546 15.8783ZM9.75436 17.4185C10.3146 17.4185 10.7569 17.8654 10.7569 18.4452C10.7569 19.025 10.3205 19.472 9.75436 19.472C9.1882 19.472 8.75179 19.025 8.75179 18.4452C8.75179 17.8654 9.1882 17.4185 9.75436 17.4185ZM16.7546 17.4185C17.3149 17.4185 17.7572 17.8654 17.7572 18.4452C17.7572 19.025 17.3208 19.472 16.7546 19.472C16.1885 19.472 15.752 19.025 15.752 18.4452C15.752 17.8654 16.1885 17.4185 16.7546 17.4185Z"
          stroke={color ? color : `#ffffff`}
          strokeWidth="0.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={color ? "#00b0eb" : `#ffffff`}
        />
      </g>
      <defs>
        <clipPath id="clip0_32_550">
          <rect width="23" height="21" fill={color ? "#00b0eb" : `#ffffff`} />
        </clipPath>
      </defs>
    </svg>

    // <svg
    //   width="32"
    //   height="32"
    //   viewBox="0 0 32 32"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M6.66675 7.33334L7.76197 8.97616C7.91892 9.2116 8.02413 9.47766 8.07065 9.75676L9.86081 20.4977C9.94118 20.9799 10.3584 21.3333 10.8472 21.3333H22.4661C22.9638 21.3333 23.3857 20.9674 23.4561 20.4748L24.6341 12.2283C24.6513 12.1078 24.5579 12 24.4361 12H8.44453M12.6667 16H15.3334M21.3334 24.6667C22.0698 23.9303 22.0698 22.7364 21.3334 22C20.597 21.2636 19.4031 21.2636 18.6667 22C17.9304 22.7364 17.9304 23.9303 18.6667 24.6667C19.4031 25.403 20.597 25.403 21.3334 24.6667ZM13.3334 24.6667C14.0698 23.9303 14.0698 22.7364 13.3334 22C12.597 21.2636 11.4031 21.2636 10.6667 22C9.93037 22.7364 9.93037 23.9303 10.6667 24.6667C11.4031 25.403 12.597 25.403 13.3334 24.6667Z"
    //     stroke={color ? color : `#ffffff`}
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    // </svg>
  );
};

export const CloseIcon: React.FC<iconsColor> = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.53033 6.46967C7.23744 6.17678 6.76256 6.17678 6.46967 6.46967C6.17678 6.76256 6.17678 7.23744 6.46967 7.53033L7.53033 6.46967ZM16.4697 17.5303C16.7626 17.8232 17.2374 17.8232 17.5303 17.5303C17.8232 17.2374 17.8232 16.7626 17.5303 16.4697L16.4697 17.5303ZM6.46967 7.53033L16.4697 17.5303L17.5303 16.4697L7.53033 6.46967L6.46967 7.53033Z"
        fill={color ? color : `#00B0EB`}
      />
      <path
        d="M17.5303 7.53031C17.8232 7.23742 17.8232 6.76255 17.5303 6.46965C17.2374 6.17676 16.7626 6.17676 16.4697 6.46965L17.5303 7.53031ZM6.46967 16.4697C6.17678 16.7625 6.17678 17.2374 6.46967 17.5303C6.76256 17.8232 7.23744 17.8232 7.53033 17.5303L6.46967 16.4697ZM16.4697 6.46965L6.46967 16.4697L7.53033 17.5303L17.5303 7.53031L16.4697 6.46965Z"
        fill={color ? color : `#00B0EB`}
      />
    </svg>
  );
};

export const HomeIcon: React.FC<iconsColor> = ({ color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.6665 25.3332V14.3624C6.6665 13.7165 6.97844 13.1104 7.50403 12.7349L14.8374 7.49684C15.5328 7.00013 16.4669 7.00013 17.1623 7.49684L24.4956 12.7349C25.0212 13.1104 25.3332 13.7165 25.3332 14.3624V25.3332"
        stroke={color ? color : `#FFFFFF`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 25.3333C11 25.8856 11.4477 26.3333 12 26.3333C12.5523 26.3333 13 25.8856 13 25.3333H11ZM19 25.3333C19 25.8856 19.4477 26.3333 20 26.3333C20.5523 26.3333 21 25.8856 21 25.3333H19ZM13 25.3333V20H11V25.3333H13ZM12 20C13 20 13 20.0005 13 20.0009C13 20.0011 13 20.0015 13 20.0018C13 20.0023 13 20.0028 13 20.0032C13 20.004 13 20.0047 13 20.005C13 20.0058 13 20.0057 13 20.0047C13 20.0026 13.0001 19.9971 13.0004 19.9884C13.001 19.9709 13.0023 19.9406 13.0053 19.8994C13.0112 19.8166 13.0235 19.6918 13.0489 19.5394C13.1005 19.2299 13.2018 18.8325 13.3944 18.4472C13.5851 18.0658 13.8554 17.7149 14.2422 17.4571C14.6227 17.2034 15.175 17 16 17V15C14.825 15 13.8773 15.2966 13.1328 15.7929C12.3946 16.2851 11.9149 16.9342 11.6056 17.5528C11.2982 18.1675 11.1495 18.7701 11.0761 19.2106C11.039 19.4332 11.0201 19.6209 11.0104 19.7569C11.0055 19.825 11.0029 19.8807 11.0015 19.9218C11.0008 19.9423 11.0005 19.9593 11.0003 19.9724C11.0001 19.979 11.0001 19.9846 11 19.9892C11 19.9915 11 19.9935 11 19.9953C11 19.9962 11 19.9971 11 19.9979C11 19.9982 11 19.9988 11 19.999C11 19.9995 11 20 12 20ZM16 17C16.825 17 17.3773 17.2034 17.7578 17.4571C18.1446 17.7149 18.4149 18.0658 18.6056 18.4472C18.7982 18.8325 18.8995 19.2299 18.9511 19.5394C18.9765 19.6918 18.9888 19.8166 18.9947 19.8994C18.9977 19.9406 18.999 19.9709 18.9996 19.9884C18.9999 19.9971 19 20.0026 19 20.0047C19 20.0057 19 20.0058 19 20.005C19 20.0047 19 20.004 19 20.0032C19 20.0028 19 20.0023 19 20.0018C19 20.0015 19 20.0011 19 20.0009C19 20.0005 19 20 20 20C21 20 21 19.9995 21 19.999C21 19.9988 21 19.9982 21 19.9979C21 19.9971 21 19.9962 21 19.9953C21 19.9935 21 19.9915 21 19.9892C20.9999 19.9846 20.9999 19.979 20.9997 19.9724C20.9995 19.9593 20.9992 19.9423 20.9985 19.9218C20.9971 19.8807 20.9945 19.825 20.9896 19.7569C20.9799 19.6209 20.961 19.4332 20.9239 19.2106C20.8505 18.7701 20.7018 18.1675 20.3944 17.5528C20.0851 16.9342 19.6054 16.2851 18.8672 15.7929C18.1227 15.2966 17.175 15 16 15V17ZM19 20V25.3333H21V20H19Z"
        fill={color ? color : `#FFFFFF`}
      />
    </svg>
  );
};

export const CheckMark: React.FC<iconsColor> = ({ color }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5638 7.33875C2.29066 7.02737 1.81679 6.99637 1.50541 7.26951C1.19402 7.54266 1.16302 8.01652 1.43617 8.32791L2.5638 7.33875ZM4.10988 10.2386L3.54606 10.7332H3.54606L4.10988 10.2386ZM5.5306 10.3225L5.02888 9.76499H5.02888L5.5306 10.3225ZM12.5017 5.05747C12.8096 4.78038 12.8345 4.30616 12.5575 3.99828C12.2804 3.69039 11.8061 3.66544 11.4983 3.94253L12.5017 5.05747ZM1.43617 8.32791L3.54606 10.7332L4.6737 9.74403L2.5638 7.33875L1.43617 8.32791ZM6.03233 10.8799L12.5017 5.05747L11.4983 3.94253L5.02888 9.76499L6.03233 10.8799ZM3.54606 10.7332C4.18916 11.4663 5.30745 11.5323 6.03233 10.8799L5.02888 9.76499C4.92532 9.85819 4.76557 9.84876 4.6737 9.74403L3.54606 10.7332Z"
        fill={color ? color : `#00B0EB`}
      />
    </svg>
  );
};

export const SettingIcon: React.FC<iconsColor> = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1873 6.13379C11.5862 5.57728 12.4138 5.57728 12.8127 6.13379L13.4755 7.05832C13.6973 7.36768 14.0754 7.52432 14.451 7.46238L15.5733 7.27726C16.2489 7.16584 16.8342 7.75106 16.7227 8.42667L16.5376 9.54903C16.4757 9.92459 16.6323 10.3027 16.9417 10.5245L17.8662 11.1873C18.4227 11.5862 18.4227 12.4138 17.8662 12.8127L16.9417 13.4755C16.6323 13.6973 16.4757 14.0754 16.5376 14.451L16.7227 15.5733C16.8342 16.2489 16.2489 16.8342 15.5733 16.7227L14.451 16.5376C14.0754 16.4757 13.6973 16.6323 13.4755 16.9417L12.8127 17.8662C12.4138 18.4227 11.5862 18.4227 11.1873 17.8662L10.5245 16.9417C10.3027 16.6323 9.92459 16.4757 9.54903 16.5376L8.42667 16.7227C7.75106 16.8342 7.16584 16.2489 7.27726 15.5733L7.46238 14.451C7.52432 14.0754 7.36768 13.6973 7.05832 13.4755L6.13379 12.8127C5.57728 12.4138 5.57728 11.5862 6.13379 11.1873L7.05832 10.5245C7.36768 10.3027 7.52432 9.92459 7.46238 9.54903L7.27726 8.42667C7.16584 7.75106 7.75106 7.16584 8.42667 7.27726L9.54903 7.46238C9.92459 7.52432 10.3027 7.36768 10.5245 7.05832L11.1873 6.13379Z"
        stroke={color ? color : "#F1F5F8"}
        strokeWidth={"1.5"}
      />
      <circle
        cx="12"
        cy="12"
        r="1.75"
        stroke={color ? color : "#F1F5F8"}
        strokeWidth="1.5"
      />
    </svg>
  );
};

interface GpsIconProps {
  color?: string;
  width?: number;
  height?: number;
}

export const GpsIcon: React.FC<GpsIconProps> = ({ color, width, height }) => {
  return (
    <svg
      width={width ? width : "12"}
      height={height ? height : "24"}
      viewBox="5 1 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Teardrop shape with hole cutout using path subtraction */}
      <path
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z M9 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0z"
        fill={color ? color : "#363A3D"}
        fillRule="evenodd"
      />
    </svg>
  );
};

interface ArrowProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export const Arrow: React.FC<ArrowProps> = ({
  width,
  height,
  color,
  className,
}) => (
  <svg
    width={width ? width : "14"}
    height={height ? height : "14"}
    viewBox="1 6 16 16"
    fill={color ? color : "white"}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <polygon points="6,9 18,9 12,17" />
  </svg>
);

interface XIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const XIcon: React.FC<XIconProps> = ({ width, height, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width ? width : "16"}
    height={height ? height : "16"}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

interface CheckIconProps {
  color?: string;
  size?: number;
  className?: string;
}

export const CheckIcon: React.FC<CheckIconProps> = ({
  color,
  size,
  className,
}) => {
  return (
    <svg
      width={size ? size : "14"}
      height={size ? size : "14"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.5638 7.33875C2.29066 7.02737 1.81679 6.99637 1.50541 7.26951C1.19402 7.54266 1.16302 8.01652 1.43617 8.32791L2.5638 7.33875ZM4.10988 10.2386L3.54606 10.7332H3.54606L4.10988 10.2386ZM5.5306 10.3225L5.02888 9.76499H5.02888L5.5306 10.3225ZM12.5017 5.05747C12.8096 4.78038 12.8345 4.30616 12.5575 3.99828C12.2804 3.69039 11.8061 3.66544 11.4983 3.94253L12.5017 5.05747ZM1.43617 8.32791L3.54606 10.7332L4.6737 9.74403L2.5638 7.33875L1.43617 8.32791ZM6.03233 10.8799L12.5017 5.05747L11.4983 3.94253L5.02888 9.76499L6.03233 10.8799ZM3.54606 10.7332C4.18916 11.4663 5.30745 11.5323 6.03233 10.8799L5.02888 9.76499C4.92532 9.85819 4.76557 9.84876 4.6737 9.74403L3.54606 10.7332Z"
        fill={color ? color : "#00B0EB"}
      />
    </svg>
  );
};

interface IconProps {
  color?: string;
  size?: number;
}

export const PlusIcon: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size ? size : "14"}
    height={size ? size : "14"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="12"
      y1="5"
      x2="12"
      y2="19"
      stroke={color ? color : "#363A3D"}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="5"
      y1="12"
      x2="19"
      y2="12"
      stroke={color ? color : "#363A3D"}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const MinusIcon: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size ? size : "14"}
    height={size ? size : "14"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="5"
      y1="12"
      x2="19"
      y2="12"
      stroke={color ? color : "#363A3D"}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
